import styled from "@emotion/styled";

import { DynamicContentBookmark } from "./dynamics";

export const StyledContentBookmark = styled(DynamicContentBookmark)`
  inline-size: 18px;
  block-size: 18px;
  padding: 0;

  path:last-of-type {
    fill: #001246;
  }
`;
